<template>
  <div class="page-img-wrapper">
    <vs-avatar class="page-img" size="33px" :src="page.avatar" loading="lazy" alt="page"/>
    <div class="rs">
      <vs-avatar
        color="transparent"
        v-if="page.network === 'facebook'"
        size="18px"
        :src="require('../../assets/img/icon_fb.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'twitter'"
        size="18px"
        :src="require('../../assets/img/icon_tw.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'linkedin'"
        size="18px"
        :src="require('../../assets/img/icon_linkedin.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'telegram'"
        size="18px"
        :src="require('../../assets/img/icon_telegram.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'bluesky'"
        size="18px"
        :src="require('../../assets/img/icon_bluesky.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'instagram'"
        size="18px"
        :src="require('../../assets/img/icon_instagram.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'pinterest'"
        size="18px"
        :src="require('../../assets/img/icon_pinterest.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'google'"
        size="18px"
        :src="require('../../assets/img/ico-google-circle.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'oneSignal'"
        size="18px"
        :src="require('../../assets/img/icon_onesignal.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'wonderpush'"
        size="18px"
        :src="require('../../assets/img/icon_wonderpush.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'batch'"
        size="18px"
        :src="require('../../assets/img/icon_batch.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'tiktok'"
        size="18px"
        :src="require('../../assets/img/icon_tiktok.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'youtube'"
        size="18px"
        :src="require('../../assets/img/ico-youtube-circle.svg')"
      />
      <!-- <vs-avatar
        v-else-if="page.network === 'youtube'"
        size="18px"
        text="YT"
        color="#ff0000"
      /> -->
      <!-- <vs-avatar
        v-else-if="page.network === 'youtube'"
        size="18px"
        text="YT"
        color="#ff0000"
      /> -->
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'threads'"
        size="18px"
        :src="require('../../assets/img/icon_threads.png')"
      />
      <vs-avatar
        color="transparent"
        v-else-if="page.network === 'whatsapp'"
        size="18px"
        :src="require('../../assets/img/icon_whatsapp.png')"
      />
    </div>
  </div>    
</template>

<script>

export default {
  name: 'page-image-avatar',

  props: {
    page: Object,
  }, 

  data(){
    return {}
  },
}    
</script>